import { queryOptions } from "@tanstack/react-query";

import {
  getDomainAliasesView,
  getDomainDnsView,
  getIdentitiesView,
  getVerifiedIdentityOptions,
} from "./server-fns";

export function identitiesQueryKey() {
  return ["identities"] as const;
}

export function identitiesQueryOptions() {
  return queryOptions({
    queryKey: identitiesQueryKey(),
    queryFn: () => getIdentitiesView(),
    staleTime: 60_000,
  });
}

export function domainAliasesQueryKey(domainId: string) {
  return ["domainAliases", domainId] as const;
}

export function domainAliasesQueryOptions(domainId: string) {
  return queryOptions({
    queryKey: domainAliasesQueryKey(domainId),
    queryFn: () => getDomainAliasesView({ data: { domainId } }),
    staleTime: 60_000,
  });
}

export function domainDnsQueryKey(domainId: string) {
  return ["domainDns", domainId] as const;
}

export function domainDnsQueryOptions(domainId: string, forceRefresh = false) {
  return queryOptions({
    queryKey: [...domainDnsQueryKey(domainId), { forceRefresh }] as const,
    queryFn: () => getDomainDnsView({ data: { domainId, forceRefresh } }),
    staleTime: forceRefresh ? 0 : 60_000,
  });
}

export function verifiedIdentityOptionsQueryOptions() {
  return queryOptions({
    queryKey: ["verifiedIdentityOptions"],
    queryFn: () => getVerifiedIdentityOptions(),
    staleTime: 60_000,
  });
}
